import { createApp } from 'vue'
import App from './App.vue'
import './assets/tailwind.css'
import './registerServiceWorker'

createApp(App).mount('#app')
